<!-- 
NOTES
   1) Side widget not arrangable

-->

<template>
   <div id="dashboard-container">
      <!-- Without dispute, Dashboard is a product -->
      <!-- Main Widget Section -->
      <Aside />
      <Main>
         <Navbar />

         <Transition name="fade" mode="out-in">
            <AddWidget v-if="controller.status" />
         </Transition>
         <OtpModal></OtpModal>
         <FeatureAnnouncement ref="featureAnnouncement" cookieName="feature_announcement_seen" v-if="false">
            <div class="announcement-popup-text">
               <span class="title">{{ $t("featureAnnouncement_TitleDarkMode") }}</span>
               <span class="sub-title">{{ $t("featureAnnouncement_ContentDarkMode") }}</span>
            </div>
            <div class="theme-option-container">
               <button type="button" class="theme-option" :class="{ active: darkModeEnabled }" @click="setTheme('dark-theme')">
                  <div class="theme-skeleton-card dark">
                     <span class="skeleton avatar"></span>
                     <span class="skeleton line w-90"></span>
                     <span class="skeleton line w-70"></span>
                     <span class="skeleton line w-85"></span>
                     <span class="skeleton line w-60"></span>
                     <span class="skeleton line w-75"></span>
                  </div>
                  <span class="theme-label">{{ $t("featureAnnouncement_lblDarkTheme") }}</span>
               </button>
               <button type="button" class="theme-option" :class="{ active: !darkModeEnabled }" @click="setTheme('light-theme')">
                  <div class="theme-skeleton-card light">
                     <span class="skeleton avatar"></span>
                     <span class="skeleton line w-90"></span>
                     <span class="skeleton line w-70"></span>
                     <span class="skeleton line w-85"></span>
                     <span class="skeleton line w-60"></span>
                     <span class="skeleton line w-75"></span>
                  </div>
                  <span class="theme-label">{{ $t("featureAnnouncement_lblLightTheme") }}</span>
               </button>
            </div>
            <button type="button" class="dark-mode-toggle" @click="toogleCloseAnnouncement">
               {{ $t("featureAnnouncement_btnClose") }}
            </button>
         </FeatureAnnouncement>

         <div id="dashboard-widgets-wrapper">
            <div class="dashboard-widgets-row row">
               <div class="dashboard-main-widgets-wrapper col-12 col-xxl-9">
                  <!-- Header Row Common -->
                  <div class="dashboard-main-header-wrapper row">
                     <div class="col-12 col-lg-6">
                        <Shortcuts />
                     </div>
                     <div class="col-6 d-none d-lg-block">
                        <AccountCard :properties="widgets.side.balance" />
                     </div>
                  </div>
                  <!-- Header Row Common -->
                  <div class="row">
                     <div class="col-12 d-block d-sm-none">
                        <TargetAchivementVue class="mb-0 mt-4" v-if="isMobile" />
                     </div>
                  </div>

                  <!-- Main Widgets Arrangable Section -->
                  <div class="dashboard-main-widgets col-12">
                     <div class="dashboard-main-widgets-row row gy-4">
                        <template v-for="(widget, index) in widgets.main">
                           <div class="col-md-12 col-lg-6 col-12" :key="index" :class="widget.type == 3 ? 'col-lg-12' : 'col-md-6'">
                              <Widget :properties="widget" @dynamicFeed="handlerFetchWidget" @removeWidget="handlerRemoveWidget" />
                           </div>
                        </template>
                     </div>
                  </div>
               </div>

               <!-- Side Widgets Non-Arrangable Section -->
               <div class="dashboard-side-widgets-wrapper col-3 d-none d-xxl-flex">
                  <div class="dashboard-side-widgets">
                     <Campaign :properties="widgets.side.campaigns" />
                     <TargetAchivementVue v-if="!isMobile" />
                     <Widget :properties="widgets.side.announcements" side />
                  </div>
               </div>
            </div>
         </div>
      </Main>
   </div>
</template>

<script>
import Aside from "@/components/unitary/Aside.vue";
import Navbar from "@/components/unitary/Navbar.vue";
import Main from "@/components/unitary/Main.vue";

import Shortcuts from "@/components/widgets/Shortcuts.vue";
import AccountCard from "@/components/widgets/AccountCard.vue";

import AddWidget from "@/components/structural/dashboard/AddWidget.vue";
import Widget from "@/components/widgets/base/Widget.vue";
import WidgetControls from "@/components/widgets/helpers/widget-helpers.js";
import { dashboardService } from "@/service/index.js";
import dummyResponse2 from "@/components/widgets/helpers/dummyResponse2";
import Campaign from "@/components/widgets/Campaign.vue";
import TargetAchivementVue from "@/pages/TargetAchivement.vue";

import OtpModal from "./OtpModal.vue";
import FeatureAnnouncement from "@/components/FeatureAnnouncement.vue";

export default {
   name: "Dasboard",
   components: {
      Aside,
      Navbar,
      Main,
      Shortcuts,
      AddWidget,
      Widget,
      AccountCard,

      OtpModal,
      FeatureAnnouncement,
      Campaign,
      TargetAchivementVue,
   },
   data() {
      return {
         controller: {
            status: false,
            widgets: [],
         },
         widgets: {
            main: [],
            side: {
               announcements: {
                  name: "dashboardPage_announcements",
                  type: "announcement",
                  pending: true,
                  content: null,
               },
               campaigns: {
                  name: "dashboardPage_campaigns",
                  type: "campaign",
                  pending: true,
                  content: null,
               },
               balance: {
                  name: "Balance",
                  type: "balance",
                  pending: true,
                  content: null,
               },
            },
         },
         dragFrom: null,
         dropTo: null,
         darkModeEnabled: false,
      };
   },

   created() {
      this.syncThemeState();
      this.handlerGenerator(dummyResponse2, "reservations", false, 1, 0);
      this.handlerGenerator(dummyResponse2, "upcomings", false, 2, 1);
      this.handlerGenerator(dummyResponse2, "reportGiros", false, 3, 2);

      this.widgets.main.forEach((widget) => {
         widget.pending = true;
      });

      // clear widget status
      // this.widgets.main = [];
      // this.controller.widgets = [];

      //Generate Dashboard Widgets
      this.handlerGetReservations();
      this.handlerGetUpcomings();
      this.handlerGetReportGiros();
      this.handlerGetAnnouncements();
      this.handlerGetAgencyBalance();
   },

   computed: {
      isMobile() {
         return this.$store.state.app.clientInformations.isMobile;
      },
   },
   methods: {
      handlerGetReservations() {
         dashboardService.GetReservations({ widgetItem: 100, expiredFlights: false }).then((response) => {
            this.handlerGenerator(response, "reservations", false, 1, 0);
         });
      },
      handlerGetUpcomings() {
         dashboardService.GetUpcomings({ widgetItem: 200, onlyFltWksc: false }).then((response) => {
            this.$store.commit("app/setUpcomingsDate", response.dateInfo);
            this.handlerGenerator(response, "upcomings", false, 2, 1);
         });
      },
      handlerGetReportGiros() {
         dashboardService.GetReportGiros({ widgetItem: 300 }).then((response) => {
            this.$store.commit("app/setGirosGrandTotal", response.grandTotal);
            this.$store.commit("app/setGirosDate", response.dateInfo);
            this.handlerGenerator(response, "reportGiros", false, 3, 2);
         });
      },
      handlerGetAnnouncements() {
         dashboardService.GetAnnouncements({}).then((response) => {
            // announcements widget content
            this.widgets.side.announcements.pending = false;
            this.widgets.side.announcements.content = response.announcements;

            // campaigns widget content
            this.widgets.side.campaigns.pending = false;
            this.widgets.side.campaigns.content = response.campaigns;
         });
      },
      handlerGetAgencyBalance() {
         dashboardService.GetAgencyBalance({}).then((response) => {
            // balance widget content
            this.widgets.side.balance.pending = false;
            this.widgets.side.balance.content = response.agencyBalance;
         });
      },
      handlerGenerator(response, column, isPending, type, index) {
         const widget = WidgetControls.modelGenerator({
            name: this.$options.filters.widgets2(type),
            property: this.$options.filters.EDashMainWidgetType(type),
            fltWkscCount: column == "upcomings" ? response?.upcomings.filter((item) => item.fltWkscTaskId > 0).length : null,
            type: type,
            order: index,
            privacy: false,
            get content() {
               return response[column];
            },
         });
         widget.pending = isPending ?? false;
         this.controller.widgets.push(type);
         this.$set(this.widgets.main, index, widget);
      },
      handlerFetchWidget(fetch) {
         this.widgets.main[fetch.order].content = fetch.content;
      },
      handlerRemoveWidget(type) {
         const query = {
            main: [],
            side: [],
         };

         this.widgets.main.forEach((widget) => {
            if (widget.type != type) {
               query.main.push(widget.type);
            }
         });
      },
      toggleDarkMode() {
         const nextTheme = this.darkModeEnabled ? "light-theme" : "dark-theme";
         this.setTheme(nextTheme);
      },
      setTheme(theme) {
         this.darkModeEnabled = theme === "dark-theme";
         localStorage.setItem("user-theme", theme);
         document.documentElement.className = theme;
      },
      toogleCloseAnnouncement() {
         if (this.$refs.featureAnnouncement) {
            this.$refs.featureAnnouncement.close();
         }
      },
      syncThemeState() {
         const storedTheme = localStorage.getItem("user-theme");
         if (storedTheme) {
            this.darkModeEnabled = storedTheme === "dark-theme";
            document.documentElement.className = storedTheme;
            return;
         }
         this.darkModeEnabled = document.documentElement.classList.contains("dark-theme");
      },
   },
   watch: {
      dropTo: {
         handler: function () {
            const widgetA = this.widgets.main.findIndex((item) => item.type == this.dragFrom.type);
            const widgetB = this.widgets.main.findIndex((item) => item.type == this.dropTo.type);
            this.widgets.main[widgetA].order = widgetB;
            this.widgets.main[widgetB].order = widgetA;
            this.handlerSortWidgets("main");
         },
      },

      "$i18n.locale": {
         handler: function () {
            this.widgets.side.announcements.pending = true;
            this.widgets.side.campaigns.pending = true;
            this.handlerGetAnnouncements();
         },
         immediate: true,
      },
   },
};
</script>

<style lang="scss" scoped>
#dashboard-container {
   #dashboard-widgets-wrapper {
      padding: 1rem 1rem;
      @media (min-width: 992px) {
         padding: 1rem 2rem;
      }

      .dashboard-main-widgets {
         margin-top: 1.5rem;
      }
      .dashboard-side-widgets {
         display: flex;
         flex-direction: column;
         width: 100%;
         position: sticky;
         top: 10px;
         height: fit-content;

         ::v-deep {
            .widget-base-container {
               height: auto;
               margin-bottom: 1.5rem;

               .widget-header-container {
                  .drag-widget,
                  .toggle-informations {
                     display: none !important;
                  }
               }

               .widget-body-container {
                  padding-left: 0.75rem;
                  padding-right: 0.75rem;
               }
            }
         }
      }
      .dashboard-widgets-row {
      }
   }
   .announcement-popup-text {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      margin: 1rem 0;
      min-width: 200px;

      .title {
         margin-bottom: 0.5rem;
         color: var(--txt-color);
      }
      .sub-title {
         font-size: var(--large);
      }
   }
   .theme-option-container {
      display: flex;
      gap: 1.5rem;
      margin: 0.5rem 0 0.25rem;
      flex-wrap: wrap;
      justify-content: center;
      margin-bottom: 2rem;
   }
   .theme-option {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      gap: 0.6rem;
      min-width: 140px;
      width: 160px;
      height: auto;
      min-height: 190px;
      border-radius: 1.25rem;
      border: 1px solid var(--gray-200);
      background: var(--surface-level-1);
      cursor: pointer;
      transition: all 0.2s ease;
      padding: 0.75rem;
      text-align: center;

      .theme-skeleton-card {
         width: 100%;
         height: auto;
         border-radius: 1rem;
         padding: 0.75rem;
         box-sizing: border-box;
         display: flex;
         flex-direction: column;
         align-items: center;
         gap: 0.5rem;
         background: var(--surface-level-2, #f5f7fb);
         overflow: hidden;
      }
      .skeleton {
         display: block;
         position: relative;
         overflow: hidden;
         background: var(--skeleton-base, #e0e6f0);
         &::after {
            display: none;
         }
      }
      .skeleton.avatar {
         width: 64px;
         height: 64px;
         border-radius: 50%;
      }
      .skeleton.line {
         height: 10px;
         border-radius: 0.5rem;
      }
      .skeleton.line.w-90 {
         width: 90%;
      }
      .skeleton.line.w-85 {
         width: 85%;
      }
      .skeleton.line.w-75 {
         width: 75%;
      }
      .skeleton.line.w-70 {
         width: 70%;
      }
      .skeleton.line.w-60 {
         width: 60%;
      }
      .theme-skeleton-card.dark {
         --skeleton-base: #525560;
         --skeleton-highlight: rgba(255, 255, 255, 0.4);
         background: #34373d;
         border: 1px solid #3a3d45;
      }
      .theme-skeleton-card.light {
         --skeleton-base: #e2e7f0;
         --skeleton-highlight: rgba(255, 255, 255, 0.7);
         background: #f6f8fe;
         border: 1px solid #d5dae6;
      }

      .theme-label {
         font-weight: 600;
         font-size: var(--normal);
         color: var(--txt-color);
      }
      &.active {
         border-color: var(--primary);
         box-shadow: 0 0 0 3px var(--primary-20, rgba(0, 123, 255, 0.2));
         .theme-label {
            color: var(--txt-color);
         }
      }
      &:hover {
         transform: translateY(-2px);
      }
   }
   .dark-mode-toggle {
      margin-top: 1rem;
      padding: 0.65rem 1.2rem;
      border-radius: 0.75rem;
      border: 1px solid var(--primary);
      background: var(--primary);
      color: var(--surface-level-1);
      font-weight: 600;
      cursor: pointer;
      transition: all 0.2s ease;

      &:hover {
         background: transparent;
         color: var(--primary);
      }
   }
}
</style>

<style lang="scss">
#dashboard-container {
   .border {
      padding: 0.5rem;
   }
}
</style>
